import { typedFetch } from "@/lib/helpers";
import { API_METHODS } from "../shared";
import { getLinkCustomerKrossUrl } from "./api-url.constants";
import {
  LinkCustomerKrossError,
  LinkCustomerKrossInvalidCredentialsError,
  LinkCustomerKrossConnectionError,
  LinkCustomerKrossApiError,
} from "./errors";

interface LinkCustomerKrossBody {
  hotelId: string;
  username: string;
  password: string;
  userId?: string;
}

export const linkCustomerKross = async (body: LinkCustomerKrossBody): Promise<void> => {
  const response = await typedFetch(getLinkCustomerKrossUrl(body.userId), {
    method: API_METHODS.POST,
    body: JSON.stringify({
      hotelId: body.hotelId,
      username: body.username,
      password: body.password,
    }),
  });

  if (!response.ok) {
    // Handle specific HTTP status codes
    if (response.status === 401 || response.status === 403 || response.status === 400) {
      throw new LinkCustomerKrossInvalidCredentialsError();
    } else if (response.status === 503) {
      throw new LinkCustomerKrossConnectionError();
    } else if (response.status === 502 || response.status === 500) {
      throw new LinkCustomerKrossApiError();
    } else if (response.status === 404) {
      throw new LinkCustomerKrossApiError();
    } else if (response.status >= 400 && response.status < 500) {
      throw new LinkCustomerKrossInvalidCredentialsError();
    }

    // For all other errors, throw the generic error
    throw new LinkCustomerKrossError();
  }
};
